import React from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader, Input, Button, Label } from "reactstrap";
import CustomHeader from "../../../Components/Common/CustomHeader";
import { Link } from "react-router-dom";

type CustomersFiltersProps = {
    isOpen: boolean;
    onToggle: () => void;
    filters: {
        search: string;
        document: string;
        email: string;
        firstName: string;
        lastName: string;
        hasEmail: boolean;
    };
    onChange: (name: string, value: string | boolean) => void;
    onApply: () => void;
    onClear: () => void;
};

export const CustomersFilters: React.FC<CustomersFiltersProps> = ({
    isOpen,
    onToggle,
    filters,
    onChange,
    onApply,
    onClear
}) => {
    return (
        <Offcanvas isOpen={isOpen} toggle={onToggle} direction="start" className="d-flex flex-column">
            <CustomHeader title="Filtros de Clientes" onClose={onToggle} component={OffcanvasHeader} />
            <OffcanvasBody className="flex-grow-1">
                <div className="d-flex mb-2 justify-content-end">
                    <Link to="#" className="text-decoration-underline" onClick={(e) => {
                        e.preventDefault();
                        onClear();
                    }}>
                        Limpiar filtros
                    </Link>
                </div>

                <div className="mb-4">
                    <Label htmlFor="search-input" className="form-label text-muted text-uppercase fs-12 fw-bold">
                        - Búsqueda General -
                    </Label>
                    <Input
                        type="text"
                        id="search-input"
                        name="search"
                        className="form-control"
                        placeholder="Nombres, Correo, Documento o Teléfono"
                        value={filters.search}
                        onChange={(e) => onChange(e.target.name, e.target.value)}
                    />
                </div>

                <Label htmlFor="phone-input" className="form-label text-muted text-uppercase fs-12 fw-bold">
                    - Búsqueda exacta -
                </Label>

                <div className="mb-3">
                    <Label htmlFor="firstName-input" className="form-label text-muted text-uppercase fs-12 fw-medium">Nombres</Label>
                    <Input
                        type="text"
                        id="firstName-input"
                        name="firstName"
                        className="form-control"
                        placeholder="Buscar por nombres"
                        value={filters.firstName}
                        onChange={(e) => onChange(e.target.name, e.target.value)}
                    />
                </div>

                <div className="mb-3">
                    <Label htmlFor="lastName-input" className="form-label text-muted text-uppercase fs-12 fw-medium">Apellidos</Label>
                    <Input
                        type="text"
                        id="lastName-input"
                        name="lastName"
                        className="form-control"
                        placeholder="Buscar por apellidos"
                        value={filters.lastName}
                        onChange={(e) => onChange(e.target.name, e.target.value)}
                    />
                </div>

                <div className="mb-3">
                    <Label htmlFor="document-input" className="form-label text-muted text-uppercase fs-12 fw-medium">Documento</Label>
                    <Input
                        type="text"
                        id="document-input"
                        name="document"
                        className="form-control"
                        placeholder="Buscar por documento"
                        value={filters.document}
                        onChange={(e) => onChange(e.target.name, e.target.value)}
                    />
                </div>

                <div className="mb-3">
                    <Label htmlFor="email-input" className="form-label text-muted text-uppercase fs-12 fw-medium">Correo Electrónico</Label>
                    <Input
                        type="email"
                        id="email-input"
                        name="email"
                        className="form-control"
                        placeholder="Buscar por email"
                        value={filters.email}
                        onChange={(e) => onChange(e.target.name, e.target.value)}
                    />
                </div>

                <div className="mb-3 form-check form-switch form-switch-md" dir="ltr">
                    <Input
                        type="checkbox"
                        id="hasEmail-input"
                        name="hasEmail"
                        className="form-check-input"
                        checked={filters.hasEmail}
                        onChange={(e) => onChange(e.target.name, e.target.checked)}
                    />
                    <Label htmlFor="hasEmail-input" className="form-check-label text-muted fs-12 fw-medium ms-2">
                        Solo clientes con correo
                    </Label>
                </div>
            </OffcanvasBody>
            <div className="p-3 border-top">
                <div className="d-flex gap-2">
                    <Button
                        color="light"
                        onClick={onToggle}
                        className="w-100"
                    >
                        Cancelar
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            onApply();
                            onToggle();
                        }}
                        className="w-100"
                    >
                        Aplicar filtros
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};
